// extracted by mini-css-extract-plugin
export default {"button":"queryForm_button__mVfbv"};